<template>
  <div v-if="isPageLoaded" class="conversion-campaign-tracking-parent">
    <h4 class="conversion-campaign-title">{{ $t('Tracking') }}</h4>

    <!-- start tracking in case lead form campaign -->
    <div v-if="isLeadFormCampaign">
      <EmptyState :description="$t('created_campaign_success.empty_tracking')"></EmptyState>
    </div>
    <!-- end tracking in case lead form campaign -->

    <!-- start tracking in case advertising channel facebook -->
    <div v-if="!isSupportPixelTracking">
      <EmptyState :description="$t('created_campaign_success.empty_tracking')"></EmptyState>
    </div>
    <!-- end tracking in case lead form campaign -->

    <!-- tracking in case conversion campaign -->
    <div v-else-if="isConversionCampaign || mainEvent">
      <p class="conversion-campaign-desc">{{$t('To track actions and assess the performance of your campaigns, choose 1 of the following the below guidelines.')}}</p>
      <div class="conversion-campaign-tracking-options">
        <div class="option-one">
          <h5 class="options-title">{{ $t('Option 1: Pixel code') }}</h5>
          <!-- <p class="options-desc">{{ $t('Manually install pixel code (JS code)') }}</p> -->
          <div class="add-pixel-code">
            <h6 class="add-code-title">{{ $t('a. Add the main pixel code') }}</h6>
              <p class="add-code-desc">{{ $t('Copy the code below and paste it between the &lt;head&gt; and &lt;/head&gt; tags on your site so that it loads on every webpage.') }}</p>
              <p class="add-code-desc">{{ $t('You can add the pixel code above or below existing tracking tags in your site header.') }}</p>
              <p class="add-code-desc-last-line">{{ $t('We do not recommend you to edit or modify the code. Any changes in the code could cause the pixel not to work properly.') }}</p>
              <div class="code-actions">
                <vx-tooltip text="Copy" position="top">
                  <div @click="copyMainCode()" class="copy-icon-parent">
                    <img class="copy-icon" id="tracking-pixel-code-copy-button" src="@/assets/images/copy.svg" alt="">
                  </div>
                </vx-tooltip>
                <vx-tooltip text="Download" position="top">
                  <div @click="saveMainCodeAsText()" class="download-icon-parent">
                    <img class="download-icon" id="tracking-pixel-code-download-button" src="@/assets/images/download.svg" alt="">
                  </div>
                </vx-tooltip>
              </div>
              <div id="mainCode" class="code-box main-pixel-code-box">{{ pixelTracking.main_code }}</div>
              <input class="hidden-input" id="mainCodeInput" type="text" :value="pixelTracking.main_code">
          </div>
          <div class="add-conversion-code">
            <h6 class="add-code-title">{{$t('b. Add conversion code')}}</h6>
              <div class="flex">
                <p class="add-code-desc">{{ $t('Copy the code below and paste it in the &lt;head&gt;&lt;/head&gt; tags of the page(s) you’d like to') }}</p>
              </div>
            <p class="add-code-desc-last-line">{{ $t('track, right after the main pixel code. Otherwise, your event will not be recorded.') }}</p>
              <div class="code-actions">
                <vx-tooltip text="Copy" position="top">
                  <div @click="copyConversionCode()" class="copy-icon-parent">
                    <img class="copy-icon" id="tracking-pixel-code-copy-button" src="@/assets/images/copy.svg" alt="">
                  </div>
                </vx-tooltip>
                <vx-tooltip text="Download" position="top">
                  <div @click="saveconversionsCodeAsText()" class="download-icon-parent">
                    <img class="download-icon" id="tracking-pixel-code-download-button" src="@/assets/images/download.svg" alt="">
                  </div>
                </vx-tooltip>
              </div>
            <div id="leadCode" class="code-box lead-box">{{ mainEvent.event_trigger_code }}</div>
            <input class="hidden-input" id="leadCodeInput" type="text" :value="mainEvent.event_trigger_code">
          </div>
        </div>
        <div class="option-two">
          <h5 class="options-title">{{ $t('Option 2: S2S postback URL Integration') }}</h5>
          <!-- <p class="options-desc">{{ $t('S2S code description') }}</p> -->
            <div class="code-actions">
              <vx-tooltip text="Copy" position="top">
                <div @click="copyS2sCode()" class="copy-icon-parent">
                  <img class="copy-icon" id="tracking-pixel-code-copy-button" src="@/assets/images/copy.svg" alt="">
                </div>
              </vx-tooltip>
              <vx-tooltip text="Download" position="top">
                <div @click="saveS2sCodeAsText()" class="download-icon-parent">
                  <img class="download-icon" id="tracking-pixel-code-download-button" src="@/assets/images/download.svg" alt="">
                </div>
              </vx-tooltip>
            </div>
          <div id="s2sCode" class="code-box postback-box">{{ mainEvent.postback_url }}</div>
          <input class="hidden-input" id="s2sCodeInput" type="text" :value="mainEvent.postback_url">
        </div>
        <div class="learn-more flex">
          <p class="mr-1"> {{ $t('Click to know more about adding') }}
            <a class="learn-more-link mr-1" target="_blank" href="https://speakol.notion.site/speakol/S2S-Postback-Documentation-3d0453094d6d49479c4e3db2844d3d1e">{{ $t('Postback') }}</a>
            <span class="mr-1">{{ $t('and') }}</span>
            <a class="learn-more-link" target="_blank" href="https://speakol.notion.site/speakol/S2S-Postback-Documentation-3d0453094d6d49479c4e3db2844d3d1e">{{ $t('mobile apps tracking.') }}</a>
          </p>
        </div>
        <div class="tracking-action">
          <router-link :to="{ name: 'conversions' , query: {'testConnection' : 1} }">
            <button class="test-connections-button bg-speakol-color">Test Connection</button>
          </router-link>
        </div>
      </div>
    </div>
    <!-- tracking in case conversion campaign -->

    <!-- tracking in case others campaign -->
    <div v-else class="others-campaign-tracking-parent">
      <p class="conversion-campaign-desc">{{$t('To track actions and assess the performance of your campaigns, follow the below guidelines.')}}</p>

      <div class="conversion-campaign-tracking-options">
        <div class="option-one">
          <h5 class="options-title">{{ $t('Pixel code') }}</h5>
          <!-- <p class="options-desc">{{ $t('To track actions and assess the performance of your campaigns, choose 1 of the following the below guidelines.') }}</p> -->
          <div class="add-pixel-code">
            <h6 class="add-code-title">{{ $t('a. Add the main pixel code') }}</h6>
              <p class="add-code-desc">{{ $t('Copy the code below and paste it in the &lt;head&gt; &lt;/head&gt; tags of every page of your website. You') }}</p>
              <p class="add-code-desc-last-line">{{ $t('only need to install the main pixel code once per account, even if you are tracking muliple actions.') }}</p>
              <div class="code-actions">
                <vx-tooltip text="Copy" position="top">
                  <div @click="copyMainCode()" class="copy-icon-parent">
                    <img class="copy-icon" id="tracking-pixel-code-copy-button" src="@/assets/images/copy.svg" alt="">
                  </div>
                </vx-tooltip>
                <vx-tooltip text="Download" position="top">
                  <div @click="saveMainCodeAsText()" class="download-icon-parent">
                    <img class="download-icon" id="tracking-pixel-code-download-button" src="@/assets/images/download.svg" alt="">
                  </div>
                </vx-tooltip>
              </div>
              <div id="mainCode" class="code-box main-pixel-code-box-others-campaign">{{ pixelTracking.main_code }}</div>
              <input class="hidden-input" id="mainCodeInput" type="text" :value="pixelTracking.main_code">
          </div>
          <div class="add-conversion-code">
            <h6 class="add-code-title">{{$t('b. Create conversion if you want to track a specific event ( Optional )')}}</h6>
            <p class="add-code-desc-last-line add-code-desc-last-line-others-campaign">{{ $t('You can select the action you want to track; once it takes place on your landing page, the Speakol Pixel code will be triggered.') }}</p>
          </div>
        </div>
        <div class="tracking-action">
          <router-link :to="{ name: 'conversions-create' }">
            <button class="create-conversion-button">Create Conversion</button>
          </router-link>

          <router-link :to="{ name: 'conversions' , query: {'testConnection': 1} }">
            <button class="test-connections-button bg-speakol-color">Test Connection</button>
          </router-link>
        </div>
      </div>
    </div>
    <!-- tracking in case others campaign -->

    <!-- toaster -->
    <SpeakolNotificationToaster :show="toaster.show" :message="toaster.message" :icon="toaster.icon"
                                :closeButtonText="toaster.closeButtonText">
      <template v-slot:close>
        <vs-icon @click="toaster.show=false" class="x-icon" color="#fff" icon="speakol-cancel" icon-pack="speakol">
        </vs-icon>
      </template>
    </SpeakolNotificationToaster>
    <!-- toaster -->
  </div>
</template>

<script>
import SpeakolNotificationToaster from '@/components/SpeakolNotificationToaster'
import EmptyState from '@/components/EmptyState'

export default {
  name: 'tracking-sections',
  components: {
    SpeakolNotificationToaster,
    EmptyState
  },
  data () {
    return {
      selectedPixelTrackingEvent: 'N/A',
      campaignBriefResponse: [],
      mainEvent: null,
      isPageLoaded: false,
      advertisingChannels: [],
      pixelTracking: {
        events: {},
        main_code: ''
      },
      toaster: {
        show: false,
        message: '',
        icon: require('@/assets/images/success.svg'),
        closeButtonText: 'close'
      }
    }
  },

  computed: {
    isLeadFormCampaign () {
      return this.isCampaignOfObjectiveX(this.$constants.CAMPAIGN_OBJECTIVES_NAMES.LEAD_FORM)
    },
    isConversionCampaign () {
      return this.isCampaignOfObjectiveX(this.$constants.CAMPAIGN_OBJECTIVES_NAMES.CONVERSIONS)
    },
    isSupportPixelTracking () {
      return this.advertisingChannels.find(advertisingChannel => advertisingChannel.id === this.campaignBriefResponse.advertising_channel_id).supports_pixel
    }
  },

  async created () {
    await this.trackingDetails()
    await this.getCampaignBrief()
    this.isPageLoaded = true

    this.selectedPixelTrackingEvent = this.pixelTracking.events.add_to_cart || 'N/A'
  },
  async mounted () {
    await this.$store.dispatch('campaign/getTargetingLookups')
    this.advertisingChannels = this.$store.getters['campaign/targetingLookups'].advertising_channels
  },
  methods: {
    isCampaignOfObjectiveX (objective) {
      if (this.campaignBriefResponse && this.campaignBriefResponse.objective) {
        return this.campaignBriefResponse.objective.display_name === objective
      }

      return false
    },
    async trackingDetails () {
      const response = await window.axios.get('/recommendations/get/pixel_tracking_details?exclude=page_views')
      this.pixelTracking.events = response.data.payload.events
      this.pixelTracking.main_code = response.data.payload.main_code
    },
    async getCampaignBrief () {
      const campaignId = +this.$route.params.id
      if (!campaignId) {
        return
      }

      const response = await window.axios.get(`/campaigns/${campaignId}/brief`)
      this.campaignBriefResponse = response.data.payload
      if (this.campaignBriefResponse) {
        this.setMainEvent()
      }
    },

    setMainEvent () {
      const mainEventName = this.campaignBriefResponse.main_conversion ? this.campaignBriefResponse.main_conversion.name : null

      this.mainEvent = mainEventName ? this.pixelTracking.events[mainEventName] : null
    },

    copyMainCode () {
      const copyText = document.getElementById('mainCodeInput')
      copyText.select()
      copyText.setSelectionRange(0, 99999)
      document.execCommand('copy')
      this.toaster.show = true
      this.toaster.message = 'The Pixel Code has been copied to the clipboard.'
      setTimeout(() => {
        this.toaster.show = false
      }, 3000)
    },
    copyS2sCode () {
      const copyText = document.getElementById('s2sCodeInput')
      copyText.select()
      copyText.setSelectionRange(0, 99999)
      document.execCommand('copy')
      this.toaster.show = true
      this.toaster.message = 'The Pixel Code has been copied to the clipboard.'
      setTimeout(() => {
        this.toaster.show = false
      }, 3000)
    },
    copyConversionCode () {
      const copyText = document.getElementById('leadCodeInput')
      copyText.select()
      copyText.setSelectionRange(0, 99999)
      document.execCommand('copy')
      this.toaster.show = true
      this.toaster.message = 'The Pixel Code has been copied to the clipboard.'
      setTimeout(() => {
        this.toaster.show = false
      }, 3000)
    },

    saveTextAsFile (textToWrite, fileNameToSaveAs) {
      const textFileAsBlob = new Blob([textToWrite], {
        type: 'text/plain'
      })
      const downloadLink = document.createElement('a')
      downloadLink.download = fileNameToSaveAs
      downloadLink.innerHTML = 'Download File'
      if (window.webkitURL !== null) {
        downloadLink.href = window.webkitURL.createObjectURL(textFileAsBlob)
      } else {
        downloadLink.href = window.URL.createObjectURL(textFileAsBlob)
        downloadLink.style.display = 'none'
        document.body.appendChild(downloadLink)
      }
      downloadLink.click()
    },
    saveMainCodeAsText () {
      this.saveTextAsFile(this.pixelTracking.main_code, 'installation_code.txt')
    },
    saveconversionsCodeAsText () {
      this.saveTextAsFile(this.pixelTracking.events.lead.event_trigger_code, 'conversions_code.txt')
    },
    saveS2sCodeAsText () {
      this.saveTextAsFile(this.pixelTracking.events.lead.postback_url, 's2s_code.txt')
    },
    saveEventTriggerCodeAsText () {
      this.saveTextAsFile(
        this.selectedPixelTrackingEvent.event_trigger_code, `${this.selectedPixelTrackingEvent.key}_pixel__code.txt`
      )
    }
  }
}
</script>
<style lang="scss">
$actions-bg-color: rgba(0, 146, 215, 0.16551);
$light-black: #5b5959;
$black-with-15-opacity: rgba(0, 0, 0, 0.15);
$mobile-apps-tracking-title-color: #2c2c2c;
$full-width: 100%;
$black-color : #323232;
$white-color : white;
$speakol-color : #0092d7;
$font-weight-bold : bold;

// tracking

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.x-icon {
  cursor: pointer;
}

.conversion-campaign-tracking-parent {
  padding: 32px;
  background-color: $white-color;
  border-radius: 15px;
  margin-top: 32px;

  .conversion-campaign-title {
    color: #1d1a1a;
    font-size: 24px;
    font-weight: 500;
    margin-bottom: 6px;
  }

  .conversion-campaign-desc {
    color: $black-color;
    font-size: 14px;
    font-weight: 300;
    margin-bottom: 32px;
  }

  .conversion-campaign-tracking-options {
    // margin-bottom: 32px;
    .options-title {
      color: $mobile-apps-tracking-title-color;
      font-size: 18px;
      font-weight: $font-weight-bold;
      margin-bottom: 24px;
    }

    .options-desc {
      color: $black-color;
      font-size: 14px;
      font-weight: 300;
      margin-bottom: 24px;
    }

    .add-code-title {
      color: $black-color;
      font-size: 16px;
      font-weight: $font-weight-bold;
      margin-bottom: 8px;
    }

    .add-code-desc-last-line,
    .add-code-desc {
      color: $black-color;
      font-size: 14px;
      font-weight: 300;
    }

    .add-code-desc-last-line {
      margin-bottom: 16px;
    }

    .add-code-desc-last-line-others-campaign {
      margin-bottom: 32px;
    }

    .code-actions {
      float: right;
      position: relative;
      top: -56px;
      display: flex;
    }

    .text-action {
      cursor: pointer;
      color: $speakol-color;

      .text-action-image-parent {
        background-color: $actions-bg-color;
        width: 20px;
        height: 20px;
        border-radius: $full-width;

        img {
          width: 12px;
          position: relative;
          left: 4px;
          top: 1px;
        }
      }
    }

    .learn-more {
      margin-bottom: 32px;

      .learn-more-link {
        color: $speakol-color;
      }
    }

    .test-connections-button {
      border-radius: 4px;
      height: 40px;
      width: 137px;
      color: $white-color;
      border: 0;
      outline: 0;
      box-shadow: 0;
      cursor: pointer;
    }

    .create-conversion-button {
      margin-right: 20px;
      background-color: transparent;
      border-radius: 4px;
      height: 40px;
      width: 137px;
      color: $speakol-color;
      border: 1px solid $speakol-color;
      outline: 0;
      box-shadow: 0;
      cursor: pointer;
    }
  }

  .main-pixel-code-box-others-campaign {
    margin-bottom: 32px;
  }

  .hidden-input {
    position: absolute;
    opacity: 0;
  }

  .lead-box {
    margin-bottom: 32px !important;
  }

  .copy-icon-parent,
  .download-icon-parent {
    width: 40px;
    height: 40px;
    border-radius: $full-width;
    background-color: $actions-bg-color;
    display: inline-block;
    cursor: pointer;
  }

  .copy-icon-parent {
    margin-right: 16px;
  }

  .copy-icon-parent,
  .download-icon-parent {
    img {
      width: 20px;
      position: relative;
      top: 9px;
      left: 10px;
    }
  }

  .code-box {
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 24px;
    border: 1px solid $black-with-15-opacity;
  }

  .postback-box {
    margin-bottom: 8px;
  }
}

@media (max-width: 768px) {
  .code-actions {
    top: -10px !important;
  }

  .code-box {
    width: $full-width;
    max-width: $full-width;
    overflow-x: auto;
  }
}
</style>
